<div class="page-header-container left-wrapper flex-utility align-center">
  <div class="filters-label">{{ 'PAGES.FILTER.TITLE' | translate }}:</div>
  <form #formRef [formGroup]="form" class="row" [class.expanded]="showMoreFilters" (ngSubmit)="applySearch()">

    <button type="submit" hidden></button>

    <ng-container *ngIf="hasSearch">
      <input matInput class="input-form" id="full-text-search" type="search" formControlName="searchFormControl"
        [placeholder]="placeholderSearch | translate">
    </ng-container>

    <ng-container *ngIf="hasSapCodeSearch">
      <input matInput class="input-form" autocomplete="off" id="sap-code-search" type="search"
        formControlName="sapCodeFormControl" [placeholder]="'PAGES.FILTER.SEARCH_SAP_CODES' | translate">
    </ng-container>

    <ng-container *ngIf="isProductsType()">

      <mat-form-field class="showcase-select-field">
        <mat-select [placeholder]="'PAGES.FILTER.PLACEHOLDERS.SEARCH_LOGISTIC_STATUS' | translate"
          formControlName="logisticStatusesFormControl" multiple>
          <mat-select-trigger>
            <mat-chip-list>
              <mat-chip *ngFor="let status of form.value.logisticStatusesFormControl" [removable]="true"
                (removed)="removeChip(LOGISTIC_STATUSES, status)">
                {{ status.name | translate }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </mat-select-trigger>
          <mat-option *ngFor="let status of logisticStatuses" [value]="status">
            <p class="text-value"> {{ status.name | translate }} </p>
          </mat-option>
        </mat-select>
      </mat-form-field>


      <!-- TODO: quando cambiano i filtri occorre mantenere le chips anche se il valore non si trova tra le options -->
      <mat-form-field class="showcase-select-field">
        <mat-select [placeholder]="'PAGES.FILTER.PLACEHOLDERS.SEARCH_ALLOCATION_STATUS' | translate"
          formControlName="allocationStatusesFormControl" multiple>
          <mat-select-trigger>
            <mat-chip-list>
              <mat-chip *ngFor="let status of form.value.allocationStatusesFormControl" [removable]="true"
                (removed)="removeChip(ALLOCATION_STATUSES, status)">
                {{ status.name | translate }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </mat-select-trigger>
          <mat-option *ngFor="let status of allocationStatuses" [value]="status">
            <p class="text-value"> {{ status.name | translate }} </p>
          </mat-option>
        </mat-select>
      </mat-form-field>

    </ng-container>
    <ng-container *ngIf="isProductAllocationType()">
      <mat-form-field *ngIf="(isTraysType() || isExtraTraysType()) && selectOptions && selectOptions.commonOptions"
        class="showcase-select-field">
        <div disabled class="loading" *ngIf="loading?.includes('trayControl')">
          <div class="spinner">
            <mat-spinner class="spinner"></mat-spinner>
          </div>
        </div>
        <mat-select [placeholder]="('PAGES.FILTER.SEARCH_ALLOCATION.'+type) | translate" formControlName="trayControl"
          multiple (openedChange)="triggerEvent($event)" [compareWith]="compareTrays">
          <mat-select-trigger>
            <mat-chip-list>
              <mat-chip *ngFor="let tray of form.value.trayControl" [removable]="true" (removed)="onTrayRemoved(tray)">
                {{ getTrayCode(tray) }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </mat-select-trigger>
          <mat-option *ngFor="let option of selectOptions.commonOptions" [value]="option">
            <p class="text-value"> {{ getTrayCode(option) }} </p>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="selectOptions && selectOptions.showcases.length > 0" class="showcase-select-field">
        <div disabled class="loading" *ngIf="loading?.includes('showCaseControl')">
          <div class="spinner">
            <mat-spinner class="spinner"></mat-spinner>
          </div>
        </div>
        <mat-select [placeholder]="('PAGES.FILTER.SEARCH_ALLOCATION.ALLOCATION') | translate"
          formControlName="showCaseControl" multiple (openedChange)="triggerEvent($event)">
          <mat-select-trigger>
            <mat-chip-list>
              <mat-chip *ngFor="let tray of form.value.showCaseControl" [removable]="true"
                (removed)="onShowcaseRemoved(tray)">
                {{ getTrayCode(tray) }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </mat-select-trigger>
          <mat-option *ngFor="let option of selectOptions.showcases" [value]="option">
            <p class="text-value"> {{ getTrayCode(option) }} </p>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="isAllocationType()">

        <mat-form-field class="showcase-select-field">
          <mat-select [placeholder]="'PAGES.ALLOCATION.PLACEHOLDERS.SEARCH_STATUS' | translate"
            formControlName="productStatusControl">
            <mat-option [value]=""> </mat-option>
            <mat-option *ngFor="let status of selectStatus" [value]="status">
              <p class="text-value"> {{ sharedService.translateStatusText(status) }} </p>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="showcase-select-field">
          <mat-select formControlName="hasImageControl">
            <mat-option [value]="''">
              <p class="text-value"> {{'PAGES.FILTER.SEARCH_ALLOCATION.HAS_IMAGE.0' | translate}} </p>
            </mat-option>
            <mat-option [value]="true">
              <p class="text-value"> {{'PAGES.FILTER.SEARCH_ALLOCATION.HAS_IMAGE.1' | translate}} </p>
            </mat-option>
            <mat-option [value]="false">
              <p class="text-value"> {{'PAGES.FILTER.SEARCH_ALLOCATION.HAS_IMAGE.2' | translate}} </p>
            </mat-option>
          </mat-select>
        </mat-form-field>

      </ng-container>

      <mat-form-field class="date-picker" [class.first]="isExtraTraysType()">
        <input [min]="sharedService.getMinDateEvent(true)" [max]="sharedService.getMaxDateEvent(true)" matInput
          [matDatepicker]="picker" formControlName="dateFormControl" readonly="true"
          [placeholder]=" (isProductAllocationType() ? 'PAGES.ANALYTICS.APPOINTMENTS.SEARCH.PLACEHOLDERS.EXTRA_TRAY_DATE'  : 'PAGES.ANALYTICS.APPOINTMENTS.SEARCH.PLACEHOLDERS.DATE')| translate">
        <mat-datepicker-toggle *ngIf="form.value.dateFormControl" matSuffix (click)="clearDate()">
          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker-toggle class="date-picker-toggle" matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field *ngIf="isExtraTraysType()" class="showcase-select-field">
        <mat-select formControlName="hasBookedForSale">
          <mat-option [value]="''">
            <p class="text-value"> {{'PAGES.FILTER.SEARCH_ALLOCATION.hasBookedForSale.0' | translate}} </p>
          </mat-option>
          <mat-option [value]="true">
            <p class="text-value"> {{'PAGES.FILTER.SEARCH_ALLOCATION.hasBookedForSale.1' | translate}} </p>
          </mat-option>
          <mat-option [value]="false">
            <p class="text-value"> {{'PAGES.FILTER.SEARCH_ALLOCATION.hasBookedForSale.2' | translate}} </p>
          </mat-option>
        </mat-select>
      </mat-form-field>

    </ng-container>


    <!-- <ng-container *ngIf="false">
      <mat-form-field class="status-select-field">
        <mat-select [placeholder]="'PAGES.ALLOCATION.PLACEHOLDERS.SEARCH_STATUS' | translate"
          formControlName="statusFormControl">
          <mat-option [value]=""> </mat-option>
          <mat-option *ngFor="let status of selectStatus" [value]="status">
            <p class="text-value"> {{ sharedService.translateStatusText(status) }} </p>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container> -->

    <ng-container *ngIf="isFinanceType()">
      <input matInput class="input-form" type="search" formControlName="searchFormControl"
        [placeholder]="'PAGES.ANALYTICS.APPOINTMENTS.SEARCH.PLACEHOLDERS.FULLTEXT' | translate">

      <ng-container *ngIf="financeFilterOptions">

        <mat-form-field class="showcase-select-field">
          <mat-select [placeholder]="'PAGES.FILTER.PLACEHOLDERS.COMPANIES' | translate"
            formControlName="financeCountriesFormControl" multiple>
            <mat-select-trigger>
              <mat-chip-list>
                <mat-chip *ngFor="let financeCountry of form.value.financeCountriesFormControl" [removable]="true"
                  (removed)="removeChip(FINANCE_COUNTRIES, financeCountry)">
                  {{ (financeCountry.label || 'PAGES.FILTER.PLACEHOLDERS.ALL_COUNTRIES') | translate }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              </mat-chip-list>
            </mat-select-trigger>
            <mat-option *ngFor="let country of financeFilterOptions.countries" [value]="country">
              <p class="text-value"> {{ (country.label || 'PAGES.FILTER.PLACEHOLDERS.ALL_COUNTRIES') | translate }} </p>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="showcase-select-field">
          <mat-select [placeholder]="'PAGES.FILTER.PLACEHOLDERS.DATES' | translate"
            formControlName="financeDatesFormControl">
            <mat-option [value]="">{{'PAGES.FILTER.PLACEHOLDERS.ALL_DATES' | translate}}</mat-option>
            <mat-option *ngFor="let date of financeFilterOptions.dates" [value]="date.id">
              <p class="text-value"> {{ date.label }} </p>
            </mat-option>
          </mat-select>
        </mat-form-field>

      </ng-container>
    </ng-container>


    <ng-container *ngIf="isAnalyticsAppointmentsType()">
      <input matInput class="input-form" type="search" formControlName="searchFormControl"
        [placeholder]="'PAGES.ANALYTICS.APPOINTMENTS.SEARCH.PLACEHOLDERS.FULLTEXT' | translate">

      <mat-form-field class="date-picker">
        <input [min]="sharedService.getMinDateEvent(true)" [max]="sharedService.getMaxDateEvent(true)" matInput
          [matDatepicker]="picker" formControlName="dateFormControl" readonly="true"
          [placeholder]="'PAGES.ANALYTICS.APPOINTMENTS.SEARCH.PLACEHOLDERS.DATE' | translate">
        <mat-datepicker-toggle *ngIf="form.value.dateFormControl" matSuffix (click)="clearDate()">
          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker-toggle class="date-picker-toggle" matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="showcase-select-field">
        <mat-select [placeholder]="'PAGES.ANALYTICS.APPOINTMENTS.SEARCH.PLACEHOLDERS.COUNTRY' | translate"
          formControlName="countriesFormControl" multiple>
          <mat-select-trigger>
            <mat-chip-list>
              <mat-chip *ngFor="let country of form.value.countriesFormControl" [removable]="true"
                (removed)="removeChip(COUNTRIES, country)">
                {{ getCountryName(country) }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </mat-select-trigger>
          <mat-option *ngFor="let country of countries" [value]="country.name">
            <p class="text-value"> {{ country.name }} </p>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>


    <ng-container *ngIf="isAnalyticsProductsType()">
      <input matInput class="input-form" type="search" formControlName="searchFormControl"
        [placeholder]="'PAGES.ANALYTICS.PRODUCTS.SEARCH.PLACEHOLDERS.FULLTEXT' | translate">

      <mat-form-field class="bfs select-field">
        <mat-select [placeholder]="'PAGES.ANALYTICS.PRODUCTS.SEARCH.BFS_OPTIONS.0' | translate"
          formControlName="bfsFormControl">
          <mat-option [value]="undefined">
            <p class="text-value"></p>
          </mat-option>
          <mat-option [value]="true">
            <p class="text-value"> {{"PAGES.ANALYTICS.PRODUCTS.SEARCH.BFS_OPTIONS.1" | translate}} </p>
          </mat-option>
          <mat-option [value]="false">
            <p class="text-value"> {{"PAGES.ANALYTICS.PRODUCTS.SEARCH.BFS_OPTIONS.2" | translate}} </p>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </form>

  <div class="button-wrapper">
    <ng-container *ngIf="showMoreAndLessButtons">
      <app-bulgari-button *ngIf="showMoreFilters" [type]="'flat'" (click)="showFilters(false)"
        [customStyle]="'text-transform: capitalize;'" [text]="'PAGES.FILTER.SHOW_LESS'"></app-bulgari-button>
      <app-bulgari-button *ngIf="!showMoreFilters" [type]="'flat'" (click)="showFilters(true)"
        [customStyle]="'text-transform: capitalize;'" [text]="'PAGES.FILTER.SHOW_MORE'"></app-bulgari-button>
    </ng-container>
    <app-bulgari-button [type]="'primary'" (click)="applySearch()" [customStyle]="'text-transform: capitalize;'"
      [text]="'PAGES.ALLOCATION.APPLY'"></app-bulgari-button>
    <app-bulgari-button [type]="'flat'" (click)="reset()"
      [customStyle]="'background: transparent; border: none; text-decoration: underline; text-transform: uppercase; padding: 0 !important'"
      [text]="'PAGES.ALLOCATION.RESET_FILTER'"></app-bulgari-button>
  </div>

</div>
